import GraphSource from '../../sources/graph';
import GraphActions from '../../actions/graph';

/**
 * @param {Object} edge the edge/outcome to reset control points
 * @param {String} flowId
 * @param {String} tenantId
 * @param {String} editingToken
 * @param {String} authenticationToken
 * @param {Object} addNotification
 * @description Resets control points for the selected edge/outcome
 */
const ResetControlPoints = async (
    edge,
    flowId, 
    tenantId, 
    editingToken, 
    authenticationToken,
    addNotification,
) => {
    
    let sourceMapElement = null;
    try {
        sourceMapElement = await GraphSource.getMapElement(edge.source.id, flowId, editingToken, 'map', tenantId, authenticationToken);

        const outcome = sourceMapElement.outcomes.find(o => o.id === edge.id);       
        outcome.controlPoints = null;
        
        GraphActions.save(flowId, [sourceMapElement], null, tenantId, authenticationToken);
    } catch (error) {
        
        addNotification({
            type: 'error',
            message: `There was a problem loading or saving map element with id: ${edge.source.id} - ${error}`,
            isPersistent: true,
        });
    }    
};

export default ResetControlPoints;
